/* eslint-disable max-len */
import { MEDIA_ENGINE_CONSTANTS } from '@finder/shared/constants/app.constants';

const fsBtnClass = MEDIA_ENGINE_CONSTANTS.selectors.fsBtnClass;
const headerMeFsClass = MEDIA_ENGINE_CONSTANTS.selectors.headerMeFsClass;
const headerClass = MEDIA_ENGINE_CONSTANTS.selectors.headerClass;

/* istanbul ignore next */
const ready = function() {
    /**
     * src/app/shared/components/media-gallery/media-gallery.component.ts
     * Contains the callback "getMediaEngine" that gives access to a full
     * media engine object.
     */
    const mediaEnginePlayer = this.getMediaEngine();

    const fsBtn = mediaEnginePlayer.nativeElement.querySelector(`.${fsBtnClass}`);
    if (fsBtn) {
        fsBtn.addEventListener('click', (e) => {
            e.preventDefault();
            mediaEnginePlayer.config.callbacks.customFullscreenEnter();
        });
    }

    mediaEnginePlayer.nicelyFitMediaEngine = () => {
        // This is looking specifically for the AAG on a details page
        const aagEl = mediaEnginePlayer.nativeElement.closest('.aag');
        if (!aagEl) {
            return;
        }
        // Now look for the details node
        const detailsEl = aagEl.querySelector('.details');
        // Stop if we don't have a details node
        if (!detailsEl) {
            return;
        }

        // Get the computed values once
        const detailsStyles = window.getComputedStyle(detailsEl);
        const newHeight = parseInt(detailsStyles.height, 10) + parseInt(detailsStyles.paddingTop, 10) + parseInt(detailsStyles.paddingBottom, 10) + 'px';

        // Update at the component scope. Not everything on the page
        (mediaEnginePlayer.nativeElement
            .querySelectorAll('.me-slides .me-slides-media ul li img, .me-slides .me-slides-media ul li video') as any)
            .forEach((el) => {
                if (mediaEnginePlayer.state.fullscreen) {
                    el.style.height = '';
                } else {
                    if ((window as any).innerWidth >= 1024) {
                        el.style.height = newHeight;
                    } else {
                        el.style.height = 'auto';
                    }
                }
            });
    };

    (window as any).addEventListener('resize', mediaEnginePlayer.nicelyFitMediaEngine);
    mediaEnginePlayer.nicelyFitMediaEngine();
    mediaEnginePlayer.calculateWidths();

    // Set thumbs visible
    mediaEnginePlayer.els.container.classList.add('show-thumbs');

    setTimeout(() => {
        // Hide thumbs after a few seconds
        mediaEnginePlayer.els.container.classList.remove('show-thumbs');
    }, 3000);
};

/* istanbul ignore next */
const customFullscreenEnter = function() {
    const mediaEnginePlayer = this.getMediaEngine();

    // This specifies the first image to display on FS
    const preFullscreenMediaSrc = mediaEnginePlayer.els.slidesMediaUL.querySelector('.me-active').children[0].src;
    // This Specifies the data set to display (first one is the default images)
    mediaEnginePlayer.changeMediaSet(0);
    // This specifies the first image to display on FS
    mediaEnginePlayer.loadSlideWithSrc(preFullscreenMediaSrc);
    // This is looking for the navigation component so it can use "document"
    document.querySelector(`.${headerClass}`).classList.add(`${headerMeFsClass}`);
    mediaEnginePlayer.fullscreenEnter();
    // Needed if we are using real full-screen, not browser only
    mediaEnginePlayer.fullscreenAPIEnter();
};

/* istanbul ignore next */
const customFullscreenExit = function() {
    const mediaEnginePlayer = this.getMediaEngine();

    // This specifies the first image to display on normal state
    const preFullscreenMediaSrc = mediaEnginePlayer.els.slidesMediaUL.querySelector('.me-active').children[0].src;

    // This Specifies the data set to display (first one is the default images)
    mediaEnginePlayer.changeMediaSet(0);
    // This specifies the first image to display on normal state
    mediaEnginePlayer.loadSlideWithSrc(preFullscreenMediaSrc);
    // This is looking for the navigation component so it can use "document"
    document.querySelector(`.${headerClass}`).classList.remove(`${headerMeFsClass}`);
    mediaEnginePlayer.fullscreenExit();
    // Needed if we are using real full-screen, not browser only
    mediaEnginePlayer.fullscreenAPIExit();
    mediaEnginePlayer.nicelyFitMediaEngine();
};

/* istanbul ignore next */
const onSlideLoad = function(slideData) {
    const mediaEnginePlayer = this.getMediaEngine();

    // onSlideLoad is called prior to ready() so we must first check for the function
    // to be defined before we try to call it. Subsequent onSlideLoad() calls are fine.
    if (mediaEnginePlayer.hasOwnProperty('nicelyFitMediaEngine')) {
        mediaEnginePlayer.nicelyFitMediaEngine();
    }
};

const MEConfig = () => ({
    callbacks: {
        ready,
        customFullscreenEnter,
        customFullscreenExit,
        onSlideLoad,
    },
    layout: ['slides', 'controls', 'tabs', 'thumbnails'],
    slides: {
        autoplay: false,
        displayTime: 5000,
        fullscreenOnTouchOrClick: true,
        loop: true,
        transitionTime: 300,
        // Needed if we are using real full-screen, not browser only
        fullscreenAPIEnabled: true,
        loader: true
    },
    controls: {
        video: {
            layout: [
                'play-pause',
                'timer',
                'volume',
                'progress-bar',
                'cc'
            ]
        }
    },
    thumbnails: {
        controls: false,
        maxVisible: 'manual',
        transitionTime: 300,
        mediaSelector: false  // only HKDL currently uses this; config in vendo overrides
    },
    video: {
        autoplay: true,
        muted: true,
        unmuteOnFullscreen: true
    },
    media: []
});

export const MEDIA_ENGINE_CONFIGS = () => ({
    'snowball': MEConfig(),
    'snowball-hover-thumbs': MEConfig(),
    'snowball-no-thumbs': MEConfig()
});
